import React from 'react';

import { usePathParam } from 'react-resource-router';

import ButtonGroup from '@atlaskit/button/button-group';
import { fg } from '@atlaskit/platform-feature-flags';
import { assert, AssertionError } from '@atlassian/eoc-common';
import { useResource } from '@atlassian/eoc-rrr-helpers';

import { AutoCreateButton } from '../../../common/ui/auto-create-button';
import { CreateButton } from '../../../common/ui/create-button';
import { heartbeatsUserRightsResource } from '../../../services/resources';

export const ActionButtons = () => {
	const [teamId] = usePathParam('teamId');
	const { data: rights } = useResource(heartbeatsUserRightsResource);

	assert(
		!!rights,
		new AssertionError(
			'ActionButtons',
			'User right should be set in parent component, but somehow it is not set.',
		),
	);

	if (!rights.hasEditRight) {
		return null;
	}

	return (
		<ButtonGroup>
			{(teamId || !fg('global_heartbeats')) && <AutoCreateButton />}
			<CreateButton />
		</ButtonGroup>
	);
};
